import React, { useEffect, useRef, useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";
import EventIcon from "@mui/icons-material/Event";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import {
  displayDateFormat,
  downloadXLSXFile,
  getEndOfMonth,
  getFirstDateOfCurrentMonthPayloadFormate,
  getFirstDateOfMonth,
  getLastDateOfCurrentMonthPayloadFormat,
  getLastDateOfMonth,
  payloadDateFormat,
  Toast,
} from "../../utils/commonUtils";
import {
  Divider,
  FormControlLabel,
  Grid,
  Switch,
  TextField,
} from "@mui/material";
import FileUploader from "./fileUploader";
import { UpdateOffersApi } from "./UpdateOffersApi";
import { IconButton } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";

export default function UpdateOfferModal({ open, handleClose, offerData }) {
  console.log(offerData, "offerData ");
  const [SelectedEndDate, setSelectedEndDate] = useState(
    dayjs(getFirstDateOfMonth())
  );

  const [displayEndDate, setDisplayEndDate] = useState(displayDateFormat());

  const [SelectedStartDate, setSelectedStartDate] = useState(
    dayjs(getFirstDateOfMonth())
  );
  const [endDate, setEndDate] = useState(
    dayjs(getLastDateOfMonth()).format("YYYY-MM-DD")
  );
  const [startDateFormat, setstartDateFormat] = useState(
    dayjs(getFirstDateOfMonth()).format("YYYY-MM-DD")
  );
  console.log(startDateFormat, "endDateendDate");

  const datePickerRef2 = React.useRef();

  const [startDateOpen, setStartDateOpen] = useState(false);
  const [endDateOpen, setEndDateOpen] = useState(false);
  const datePickerOnChangeEnd = (date) => {
    setSelectedEndDate(date);

    const dateStr2 = date.toDate
      ? date.toDate().toLocaleDateString("en-GB", {
          year: "numeric",
          month: "long",
          day: "2-digit",
        })
      : date.format("DD-MMMM-YYYY");
    let dateContainer = String(dateStr2).split(" ");
    var year2 = dateContainer[2];
    var month2 = dateContainer[1];
    var day2 = dateContainer[0];
    var formattedDate2 = day2 + "-" + month2 + "-" + year2;
    setDisplayEndDate(formattedDate2);

    // Update endDate for API call
    setEndDate(date.format("YYYY-MM-DD"));
    setEndDateOpen(false);
  };

  const datePickerOnChange = (date) => {
    setSelectedStartDate(date);

    const dateStr2 = date.toDate
      ? date.toDate().toLocaleDateString("en-GB", {
          year: "numeric",
          month: "long",
          day: "2-digit",
        })
      : date.format("DD-MMMM-YYYY");
    let dateContainer = String(dateStr2).split(" ");
    var year2 = dateContainer[2];
    var month2 = dateContainer[1];
    var day2 = dateContainer[0];
    var formattedDate2 = day2 + "-" + month2 + "-" + year2;
    setStartDate(formattedDate2);

    // Update startDateFormat for API call
    setstartDateFormat(date.format("YYYY-MM-DD"));
    setStartDateOpen(false);
    setEndDateOpen(true);
  };

  const [startDate, setStartDate] = useState(displayDateFormat());
  const datePickerRef = useRef();

  const openDatePicker = () => {
    if (datePickerRef.current) {
      datePickerRef.current.setOpen(true);
    }
  };
  const [selectedFile, setSelectedFile] = useState(null);
  const [imagePreviewUrl, setImagePreviewUrl] = useState("");
  const [message, setMessage] = useState("");
  const [checked, setChecked] = React.useState(true);
  const [status, setStatus] = useState("active");
  const handleChange = (event) => {
    const isChecked = event.target.checked;
    setChecked(isChecked);
    setStatus(isChecked ? "active" : "inactive");
  };

  useEffect(() => {
    setMessage(offerData?.offerInformation);
    setImagePreviewUrl(offerData?.imagePath);
    if (offerData?.status == "active") {
      setChecked(true);
      setStatus("active");
    } else {
      setChecked(false);
      setStatus("inactive");
    }
    datePickerOnChange(dayjs(offerData?.fromDate.split("T")[0]));
    datePickerOnChangeEnd(dayjs(offerData?.toDate.split("T")[0]));
  }, [offerData]);

  const handleFileChange = (file) => {
    setSelectedFile(file);
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreviewUrl(reader.result);
      };
      reader.readAsDataURL(file);
    } else {
      setImagePreviewUrl(offerData?.imageUrl);
    }
  };

  const handleSubmit = async () => {
    const formData = new FormData();
    formData.append("Id", offerData?.id);
    formData.append("OfferInformation", message);
    formData.append("FromDate", startDate);
    formData.append("ToDate", displayEndDate);
    formData.append("Status", status);
    // formData.append("File", selectedFile);
    if (selectedFile) {
      formData.append("File", selectedFile);
    }

    await UpdateOffersApi(formData).then((res) => {
      if (res?.data?.succeeded) {
        Toast.fire({
          icon: "success",
          title: "Offer Updated succesfully.",
        });
        handleClose();
      } else {
        Toast.fire({
          icon: "error",
          title: "Something Went Wrong",
        });
      }
    });
  };

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: "95%", sm: "50%", md: "40%", lg: "30%", xl: "30%" },

            bgcolor: "background.paper",
            boxShadow: 24,
            // p: 4,
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              px: 2,
              py: 1,
              backgroundColor: "#CECEFF",
              boxShadow: 3,
            }}
          >
            <Typography
              color="#000"
              fontWeight={500}
              fontSize={{ xs: "12px", sm: "13px", md: "15px" }}
            >
              Update Offers
            </Typography>
            <IconButton onClick={() => handleClose(false)}>
              <CloseIcon
                sx={{
                  color: "#000",
                  fontSize: { xs: "14px", sm: "14px", md: "20px" },
                }}
              />
            </IconButton>
          </Box>
          <Box sx={{ px: 2, py: 1 }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "right",
                mb: 1,
                mt: 2,
              }}
            >
              {/* <DatePicker
                hidden={true}
                selected={SelectedStartDate}
                maxDate={new Date()}
                onChange={datePickerOnChange}
                className="custom-datepicker"
                ref={datePickerRef}
                onClickOutside={() => {
                  datePickerRef.current.setOpen(false);
                }}
              />

              <DatePicker
                hidden={true}
                selected={SelectedEndDate}
                maxDate={new Date()}
                onChange={datePickerOnChangeEnd}
                className="custom-datepicker"
                ref={datePickerRef2}
                onClickOutside={() => {
                  datePickerRef2.current.setOpen(false);
                }}
              />
              <TextField
                fullWidth
                readonly
                size="small"
                onClick={openDatePicker}
                id="date"
                sx={{
                  mt: 2,
                }}
                value={startDate + " To " + displayEndDate}
                label={
                  <Box
                    sx={{
                      flex: 4,
                      color: "grey",
                      cursor: "pointer",
                      whiteSpace: "nowrap",
                      color: "#01008B",
                    }}
                  >
                    Date :
                  </Box>
                }
                onChange={(e) => { }}
                InputProps={{
                  endAdornment: (
                    <EventIcon
                      sx={{
                        color: (theme) => theme.palette.primary.main,
                        cursor: "pointer",
                      }}
                    />
                  ),
                }}
              /> */}
              <TextField
                label="Date"
                size="small"
                value={
                  SelectedStartDate && SelectedEndDate
                    ? `${SelectedStartDate.format(
                        "DD-MM-YYYY"
                      )} to ${SelectedEndDate.format("DD-MM-YYYY")}`
                    : SelectedStartDate
                    ? `${SelectedStartDate.format("DD-MM-YYYY")}`
                    : ""
                }
                id="datepickerfield"
                placeholder="Select date range"
                InputProps={{
                  readOnly: true,
                  endAdornment: (
                    <CalendarMonthIcon
                      sx={{
                        cursor: "pointer",
                        mr: 1,
                      }}
                      onClick={() => setStartDateOpen(true)} // trigger open
                    />
                  ),
                  sx: {
                    background: "#fff",
                    borderRadius: 1,
                    cursor: "pointer",
                    fontFamily: "'Montserrat', sans-serif",
                    fontWeight: 500,
                    fontSize: { xs: "12px", sm: "13px", md: "20px" },
                  },
                }}
                onClick={() => setStartDateOpen(true)} // trigger open
                sx={{ width: "100%", height: "50px" }}
              />

              <Box sx={{ position: "relative" }}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    open={startDateOpen}
                    onOpen={() => setStartDateOpen(true)}
                    onClose={() => setStartDateOpen(false)}
                    value={SelectedStartDate}
                    onChange={(val) => {
                      datePickerOnChange(val);
                    }}
                    maxDate={SelectedEndDate || undefined}
                    slotProps={{
                      popper: {
                        placement: "bottom-end",
                        anchorEl: document.querySelector("#datepickerfield"),
                        sx: { zIndex: 1500 },
                      },
                      textField: { style: { display: "none" } },
                    }}
                  />
                </LocalizationProvider>

                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    open={endDateOpen}
                    onOpen={() => setEndDateOpen(true)}
                    onClose={() => setEndDateOpen(false)}
                    value={SelectedEndDate}
                    onChange={(val) => {
                      datePickerOnChangeEnd(val);
                    }}
                    minDate={SelectedStartDate || undefined}
                    slotProps={{
                      popper: {
                        placement: "bottom-start",
                        anchorEl: document.querySelector("#datepickerfield"),
                        sx: { zIndex: 1500 },
                      },
                      textField: { style: { display: "none" } },
                    }}
                  />
                </LocalizationProvider>
              </Box>
            </Box>
            <TextField
              onChange={(e) => setMessage(e.target.value)}
              sx={{
                mb: 2,
                // fontSize: { xs: "12px", sm: "13px", md: "15px" }, // ✅ input value font size
              }}
              InputProps={{
                sx: {
                  "& textarea": {
                    fontSize: { xs: "13px", sm: "13px", md: "15px" }, // ✅ correct target
                    // fontFamily: "Montserrat", // optional
                  },
                },
              }}
              fullWidth
              label="Message"
              value={message}
              multiline
              rows={3}
              maxRows={5} // Grows up to 5 rows, and then it will scroll
              variant="outlined"
            />
            <Box
              display={"flex"}
              sx={{ mb: 2 }}
              justifyContent={"space-between"}
              alignItems={"center"}
            >
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <Box display="flex" justifyContent="flex-start">
                    <FileUploader onFileSelect={handleFileChange} />
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Box
                    display="flex"
                    justifyContent="flex-end"
                    alignItems={"center"}
                  >
                    <FormControlLabel
                      control={
                        <Switch
                          checked={checked}
                          onChange={handleChange}
                          inputProps={{ "aria-label": "controlled" }}
                          sx={{ ml: 6 }}
                        />
                      }
                      label={
                        <span
                          style={{
                            color: "#01008B",
                            fontWeight: 500,
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          }}
                        >
                          Status
                        </span>
                      }
                      labelPlacement="start"
                    />
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6}>
                  {imagePreviewUrl && (
                    <Box>
                      <img
                        src={imagePreviewUrl}
                        alt="Current Offer"
                        style={{ width: 195, height: 195 }}
                      />
                    </Box>
                  )}
                </Grid>
              </Grid>
            </Box>
            <Divider
              sx={{
                borderColor: "#01008B",
                borderBottomWidth: 1.6,
                mb: 2,
              }}
            />
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Button
                onClick={handleSubmit}
                variant="contained"
                sx={{
                  width: "60%",
                  mb: 1,
                  fontSize: { xs: "12px", sm: "13px", md: "20px" },
                }}
              >
                Update
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
    </div>
  );
}
